import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'components/graylog/router';

import { Alert, Col, Row } from 'components/graylog';
import { IfPermitted } from 'components/common';
import Routes from 'routing/Routes';

class AuditLogLicenseStatus extends React.Component {
  static propTypes = {
    licenseStatus: PropTypes.shape({
      status: PropTypes.object,
      missing: PropTypes.bool.isRequired,
      loading: PropTypes.bool.isRequired,
    }).isRequired,
    colWidth: PropTypes.number,
    rowClass: PropTypes.string,
  };

  static defaultProps = {
    colWidth: 12,
    rowClass: 'content',
  };

  renderStatus = () => {
    return (
      <Alert bsStyle="danger">
        <h4 style={{ fontWeight: 'bold', marginBottom: 5 }}>Auditlog is disabled</h4>
        <p>
          Graylog will not write any new auditlog entries because there is no valid license.
        </p>
        <IfPermitted permissions="licenses:create">
          <p>
            See <Link to={Routes.pluginRoute('SYSTEM_LICENSES')}>Licenses page</Link> for details.
          </p>
        </IfPermitted>
      </Alert>
    );
  };

  render() {
    const { status, missing } = this.props.licenseStatus;

    if (!missing && (status && status.valid)) {
      return null;
    }

    const { rowClass, colWidth } = this.props;

    return (
      <Row className={rowClass}>
        <Col md={colWidth}>
          {this.renderStatus()}
        </Col>
      </Row>
    );
  }
}

export default AuditLogLicenseStatus;
